import { useTranslations } from 'next-intl'
import { ITranslationKey } from '@/components/t'
import { IChildrenProps } from '@/typings/children-props'

export const CommonBanner = ({ children, tBaseKey }: IChildrenProps & { tBaseKey: string }) => {
    const t = useTranslations()

    return (
        <div className="w-full flex items-center justify-center bg-black py-16">
            <div className="flex items-center flex-col max-w-full md:max-w-[552px] px-4 md:px-0">
                <h2 className="mr-2 text-[24px] md:text-[32px] leading-[36px] text-center text-white mb-8">
                    {t.rich(`${tBaseKey}.title` as ITranslationKey, {
                        bold: (children) => (
                            <span className="underline decoration-neotaste decoration-[7px]">
                                {children}
                            </span>
                        ),
                    })}
                </h2>

                {children}
            </div>
        </div>
    )
}
